import { render, staticRenderFns } from "./featured-collection.vue?vue&type=template&id=0a048612&scoped=true&"
import script from "./featured-collection.vue?vue&type=script&lang=js&"
export * from "./featured-collection.vue?vue&type=script&lang=js&"
import style0 from "./featured-collection.vue?vue&type=style&index=0&id=0a048612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a048612",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0a048612', component.options)
    } else {
      api.reload('0a048612', component.options)
    }
    module.hot.accept("./featured-collection.vue?vue&type=template&id=0a048612&scoped=true&", function () {
      api.rerender('0a048612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/featured-collection.vue"
export default component.exports